import React from 'react';

type ProgramWorkspaceStaleConflictBannerProps = {
  visible: boolean;
  onAcceptServer: () => void;
  onDismiss: () => void;
};

export default function ProgramWorkspaceStaleConflictBanner({
  visible,
  onAcceptServer,
  onDismiss,
}: ProgramWorkspaceStaleConflictBannerProps) {
  if (!visible) return null;
  return (
    <div className="cp-program-workspace-stale-banner" role="status">
      <p>
        다른 기기나 탭에서 이 프로그램 내용이 저장되었습니다. 미저장 편집과 충돌할 수 있습니다.
      </p>
      <div className="cp-program-workspace-stale-banner-actions">
        <button type="button" className="cp-btn cp-btn-primary cp-btn-sm" onClick={onAcceptServer}>
          서버 최신본 불러오기
        </button>
        <button type="button" className="cp-btn cp-btn-ghost cp-btn-sm" onClick={onDismiss}>
          내 편집 유지
        </button>
      </div>
    </div>
  );
}
